import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form, Input, Button } from "antd";
import { verifyOtp } from "../appRedux/actions";
import { bindActionCreators } from "redux";
import { Link, useNavigate } from 'react-router-dom';

const FormItem = Form.Item;

function VerificationForm({ form, authUser, verifyOtp }) {
  const [loading, setLoading] = useState(false);
  const { getFieldDecorator } = form;
  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        if (!loading) {
          setLoading(true);
          const data = {
            email: authUser.email,
            code: values.code,
            mode: "AUTHENTICATORAPP",
          };
          try {
            await verifyOtp(data); // waits for API to finish
          } finally {
            setLoading(false); // always stop loader
          }
        }
      }
    });
  }

  useEffect(() => {
    if (!authUser) {
      navigate("/signin");
    }
    if (authUser && authUser.authenticated) {
      navigate("/");
    }
  }, [authUser, navigate]);

  return (
    <section className="auth-layout-container">
      <div className="gx-app-login-wrap">
        <div className="verify-container">
            <div>
              <h1 className="authenticator-heading">
                Enter the 6-digit Code from the Authenticator
              </h1>
            </div>
            <div className="verify-container-block">
              <div className="gx-app-login-content">
                    <Form
                      onSubmit={handleSubmit}
                    >
                      <FormItem
                        label={
                          <span className="label-otp">
                            Enter Code
                          </span>
                        }
                      >
                        {getFieldDecorator("code", {
                          initialValue: undefined,
                          rules: [
                            { required: true, message: "Please input your code!" },
                          ],
                        })(<Input autoFocus />)}
                      </FormItem>
                      <p  style={{ textAlign: 'center', fontWeight: 400 }}>Try another way? <Link to={'/verify-account'} >Send Code via Email</Link></p>
                    </Form>
                    <p style={{ textAlign: "center", padding: '0 15px' }}>
                      Enter the verification code from your Authenticator app to proceed.
                    </p>
              </div>
            </div>
            <Button
              block 
              type="primary"
              loading={loading}
              onClick={handleSubmit}
            >
              {"Next"}
            </Button>
        </div>
      </div>
    </section>
  );
}

const VerifyAuthenticatorCode = Form.create()(VerificationForm);

export const mapDispatchToProps = (dispatch) => ({
  verifyOtp: bindActionCreators(verifyOtp, dispatch),
});

const mapStateToProps = ({ auth }) => {
  return {
    authUser: auth.authUser || null,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyAuthenticatorCode);
